

// render press
// node creation/index.js


export const ConfigData = {

    localMovieURL: 'http://localhost:8080/assets/data/movies/',
    prodMovieURL: 'https://piracyplus.com/assets/data/movies/',
    movieURL: 'https://piracyplus.com/assets/data/movies/',

    localPostsURL: 'http://localhost:3000/assets/data/posts.json',
    prodPostsURL: 'https://cinedapt.com/assets/data/posts.json',
    postsURL: 'http://localhost:3000/assets/data/posts.json',

    localBetaData: 'http://localhost:3000/assets/data/exolatry-input.json',
    prodBetaData: 'https://cinedapt.com/assets/data/exolatry-input.json',
    betaURL: 'http://localhost:3000/assets/data/exolatry-input.json'

};

export default { ConfigData };